import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AppLayout from '../../../layouts/AppLayout/AppLayout';
import { NioSection, NioButton, NioIcon } from '../../../components';
import { useTranslation } from '../../../i18n/I18nProvider';

function RequestDemandStep7() {
  const navigate = useNavigate();
  const location = useLocation();
  const { serviceId } = useParams();
  const { t } = useTranslation();

  const selectedSubService = location.state?.selectedSubService || t('common.subService');
  const parentServiceTitle = location.state?.parentServiceTitle || t('common.service');
  const projectTitle = location.state?.projectTitle || '';
  const requestDetails = location.state?.requestDetails || {};
  const requestStep4Details = location.state?.requestStep4Details || {};
  const requestStep5Details = location.state?.requestStep5Details || {};
  const requestStep6Details = location.state?.requestStep6Details || {};
  const isStep5Skipped = location.state?.isStep5Skipped || false;
  const displayStep = isStep5Skipped ? 6 : 7;

  const tunisianRegions = {
    Ariana: ['Ariana', 'Raoued', 'Kalâat el-Andalous', 'Sidi Thabet', 'Ettadhamen', 'Mnihla'],
    'Béja': ['Béja', 'Medjez el-Bab', 'Testour', 'Nefza', 'Amdoun', 'Téboursouk'],
    'Ben Arous': ['Ben Arous', 'Rades', 'Mégrine', 'Hammam Lif', 'Fouchana', 'Ezzahra', 'Mohamedia'],
    Bizerte: ['Bizerte', 'Menzel Bourguiba', 'Mateur', 'Sejnane', 'Ghar El Melh', 'Ras Jebel'],
    'Gabès': ['Gabès', 'Médenine', 'Matmata', 'El Hamma', 'Ghannouch', 'Mareth'],
    Gafsa: ['Gafsa', 'El Ksar', 'Métlaoui', 'Redeyef', 'Moularès', 'Sidi Aïch'],
    Jendouba: ['Jendouba', 'Tabarka', 'Aïn Draham', 'Fernana', 'Bou Salem', 'Ghardimaou'],
    Kairouan: ['Kairouan', 'Sbikha', 'Haffouz', 'Chebika', 'Oueslatia', 'Nasrallah'],
    Kasserine: ['Kasserine', 'Sbeitla', 'Fériana', 'Thala', 'Haïdra', 'Jedelienne'],
    'Kébili': ['Kébili', 'Douz', 'Souk Lahad', 'Faouar', 'El Golâa'],
    Kef: ['Le Kef', 'Tajerouine', 'Kalâat Khasba', 'Dahmani', 'Sers', 'Nebeur'],
    Mahdia: ['Mahdia', 'Bou Merdes', 'Chebba', 'El Jem', 'Ksour Essef', 'Sidi Alouane'],
    Manouba: ['Manouba', 'Douar Hicher', 'Oued Ellil', 'Mornag', 'Borj El Amri', 'Djedeida'],
    'Médenine': ['Médenine', 'Tataouine', 'Ben Gardane', 'Zarzis', 'Djerba', 'Houmt Souk'],
    Monastir: ['Monastir', 'Moknine', 'Ksibet el-Médiouni', 'Bembla', 'Téboulba', 'Sayada'],
    Nabeul: ['Nabeul', 'Hammamet', 'Kélibia', 'Korba', 'Menzel Temime', 'Dar Chaabane', 'Béni Khalled'],
    Sfax: ['Sfax', 'Sakiet Ezzit', 'El Hencha', 'Agareb', 'Menzel Chaker', 'Bir Ali Ben Khalifa'],
    'Sidi Bouzid': ['Sidi Bouzid', 'Meknassy', 'Regueb', 'Ouled Haffouz', 'Cebbala Ouled Asker'],
    Siliana: ['Siliana', 'Bou Arada', 'Gaâfour', 'El Krib', 'Makthar', 'Rouhia'],
    Sousse: ['Sousse', 'Hammam Sousse', 'Akouda', 'Enfidha', 'Kalaa Kebira', 'Msaken', 'Bouficha'],
    Tataouine: ['Tataouine', 'Remada', 'Bir Lahmar', 'Ghomrassen', 'Dehiba'],
    Tozeur: ['Tozeur', 'Nefta', 'Degache', 'Hazoua', 'Tamaghza'],
    Tunis: ['Tunis', 'La Marsa', 'Carthage', 'Sidi Bou Said', 'Le Bardo', 'La Goulette'],
    Zaghouan: ['Zaghouan', 'Zriba', 'Nadhour', 'Fahs', 'Saouaf', 'El Fahs'],
  };
  const sortedRegions = Object.keys(tunisianRegions).sort();
  const [region, setRegion] = useState('');
  const [city, setCity] = useState('');
  const [exactAddress, setExactAddress] = useState('');
  const availableCities = region ? [...(tunisianRegions[region] || [])].sort() : [];
  const canContinue = Boolean(region && city && exactAddress.trim());

  return (
    <AppLayout title={`${t('wizard.step', { n: displayStep })} - ${t('wizard.step7Title')}`} rootClass="layout-1">
      <style>{`
        .request-step7-page {
          background: #f2f3f5;
          min-height: 78vh;
          border-radius: 14px;
          position: relative;
          display: flex;
          flex-direction: column;
        }
        .request-step7-content {
          flex: 1 1 auto;
          width: 100%;
          max-width: 760px;
          margin: 0 auto;
          padding-top: 4.2rem;
          padding-bottom: 2rem;
        }
        .request-step7-step {
          color: #697586;
          font-size: 0.9rem;
          margin-bottom: 0.25rem;
        }
        .request-step7-heading {
          color: #0f2b3d;
          font-weight: 700;
          margin-bottom: 0.4rem;
        }
        .request-step7-description {
          color: #5f6b7a;
          margin-bottom: 3rem;
          max-width: 620px;
        }
        .request-step7-label {
          color: #0f2b3d;
          font-size: 1.05rem;
          font-weight: 500;
          margin-bottom: 0.7rem;
        }
        .request-step7-input {
          width: 100%;
          border: 1px solid #d6dde5;
          border-radius: 8px;
          height: 46px;
          padding: 0 0.9rem;
          color: #0f2b3d;
          background: #fff;
          margin-bottom: 1rem;
        }
        .request-step7-select {
          width: 100%;
          border: 1px solid #d6dde5;
          border-radius: 8px;
          height: 46px;
          padding: 0 0.9rem;
          color: #0f2b3d;
          background: #fff;
          margin-bottom: 1rem;
        }
        .request-step7-note {
          background: #eaf1ff;
          color: #2563eb;
          border-radius: 8px;
          min-height: 52px;
          display: flex;
          align-items: center;
          gap: 0.6rem;
          padding: 0.7rem 0.9rem;
          font-weight: 500;
        }
        .request-step7-footer {
          flex-shrink: 0;
          margin-top: auto;
          border-top: 1px solid #dde3ea;
          padding: 0.7rem 1.1rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f8f9fb;
          border-bottom-left-radius: 14px;
          border-bottom-right-radius: 14px;
          z-index: 5;
          box-shadow: 0 -4px 16px rgba(15, 43, 61, 0.08);
        }
      `}</style>

      <NioSection className="pt-120 pt-lg-160 pb-4">
        <NioSection.Content>
          <div className="request-step7-page p-3 p-md-4">
            <div className="request-step7-content">
              <div className="request-step7-step">{t('wizard.step', { n: displayStep })}</div>
              <h2 className="request-step7-heading">{t('wizard.step7Heading')}</h2>
              <p className="request-step7-description">
                {t('wizard.step7Description')}
              </p>

              <h3 className="request-step7-label">{t('wizard.step7Region')}</h3>
              <select
                className="request-step7-select"
                value={region}
                onChange={(event) => {
                  setRegion(event.target.value);
                  setCity('');
                }}
              >
                <option value="">{t('wizard.step7SelectRegion')}</option>
                {sortedRegions.map((regionOption) => (
                  <option key={regionOption} value={regionOption}>
                    {regionOption}
                  </option>
                ))}
              </select>

              <h3 className="request-step7-label">{t('wizard.step7City')}</h3>
              <select
                className="request-step7-select"
                value={city}
                onChange={(event) => setCity(event.target.value)}
                disabled={!region}
              >
                <option value="">{t('wizard.step7SelectCity')}</option>
                {availableCities.map((cityOption) => (
                  <option key={cityOption} value={cityOption}>
                    {cityOption}
                  </option>
                ))}
              </select>

              <h3 className="request-step7-label">{t('wizard.step7ExactAddress')}</h3>
              <input
                className="request-step7-input"
                placeholder={t('wizard.step7AddressPlaceholder')}
                value={exactAddress}
                onChange={(event) => setExactAddress(event.target.value)}
              />

              <div className="request-step7-note">
                <NioIcon name="lock" className="fs-20" />
                  <span>{t('wizard.step7PrivacyNote')}</span>
              </div>
            </div>

            <div className="request-step7-footer">
              <NioButton
                className="btn btn-primary"
                label={t('common.back')}
                onClick={() => navigate(-1)}
              />
              <NioButton
                className={`btn ${canContinue ? 'btn-primary' : 'btn-primary disabled'}`}
                label={t('common.next')}
                onClick={() => {
                  if (!canContinue) return;
                  navigate(`/service/${serviceId}/request-demand-step8`, {
                    state: {
                      selectedSubService,
                      parentServiceTitle,
                      projectTitle,
                      isStep5Skipped,
                      requestDetails,
                      requestStep4Details,
                      requestStep5Details,
                      requestStep6Details,
                      requestStep7Details: {
                        region,
                        city,
                        exactAddress: exactAddress.trim(),
                      },
                    },
                  });
                }}
              />
            </div>
          </div>
        </NioSection.Content>
      </NioSection>
    </AppLayout>
  );
}

export default RequestDemandStep7;
